// Path: frontend/src/components/shared/AdminRoute.tsx
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { usePermissions } from '@/hooks/usePermissions';
import { useSmartSkeleton } from '@/hooks/useSmartSkeleton';
import { COMMON_CHECKS } from '@/types/permissions';
import { FullPageLoader } from './FullPageLoader';

export default function AdminRoute() {
  const { user, isLoading: authLoading, isAuthenticated } = useAuth();
  const { checkPermissionWithLoading } = usePermissions();
  const showLoader = useSmartSkeleton(authLoading);

  // Check system admin permission
  const { hasPermission: isAdmin, isLoading: permissionLoading } = checkPermissionWithLoading(
    COMMON_CHECKS.ADMIN
  );

  // Show loader during authentication or permission check
  if (showLoader || permissionLoading) {
    return <FullPageLoader />;
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If the user has admin permission, allow access
  if (user && isAdmin) {
    return <Outlet />;
  }

  // If we have a user but they don't have admin permission, redirect to home
  if (user && !isAdmin && !permissionLoading) {
    return <Navigate to="/" replace />;
  }

  // If still loading permission data, show loader to prevent premature redirect
  return <FullPageLoader />;
}
